/* eslint-disable import/no-cycle */
import { all } from 'redux-saga/effects';

/** IMPORT SAGA */
import excecaoMeta from './excecaoMeta/sagas';
import recalculaTurno from './recalculaTurno/sagas';
import alteracaoCentroCusto from './alteracaoCentroCusto/sagas';
import tiposDeEquipamentosVeiculo from './tiposDeEquipamentosVeiculo/sagas';

import recebimentoAreiaNf from './recebimentoAreiaNf/sagas';
import transferenciaAreiaSilo from './transferenciaAreiaSilo/sagas';
import afericaoAreiaSilo from './afericaoAreiaSilo/sagas';
import afericaoDvec from './afericaoDvec/sagas';
import alarmeSistema from './alarmeSistema/sagas';
import alarmesSistemas from './alarmesSistemas/sagas';
import arqueacao from './arqueacao/sagas';
import arqueacaoautomatica from './arqueacaoAutomatica/sagas';
import auditoriaSistemas from './auditoriaSistemas/sagas';
import auth from './auth/sagas';
import bico from './bico/sagas';
import cadastrodvec from './cadastrodvec/sagas';
import causasManutencoes from './causasManutencoes/sagas';
import linhaAbastecimento from './linhaAbastecimento/sagas';
import centrocusto from './centrocusto/sagas';
import cercasvirtuais from './cercasVirtuais/sagas';
import checkliberadoparaintegracao from './checkliberadoparaintegracao/sagas';
import checkxmlnfrecebimentonf from './checkxmlnfrecebimentonf/sagas';
import clienteConfig from './clienteConfig/sagas';
import comboio from './comboio/sagas';
import configuracaoalarmetanque from './configuracaoalarmetanque/sagas';
import consultaavancada from './consultaAvancada/sagas';
import contrato from './contrato/sagas';
import dialog from './dialog/sagas';
import dialogForm from './dialogForm/sagas';
import conversorEntradaSaida from './conversorEntradaSaida/sagas';
import distribuidora from './distribuidora/sagas';
import drawer from './drawer/sagas';
import edicaoAlinhamentoTanque from './EdicaoOperacao/AlinhamentoTanque/sagas';
import recebimento from './EdicaoOperacao/Recebimento/sagas';
import edicaoTrocaTanque from './EdicaoOperacao/TrocaTanque/sagas';
import turno from './EdicaoOperacao/Turno/sagas';
import empresacliente from './empresacliente/sagas';
import empresaveiculo from './empresaveiculo/sagas';
import estoqueGeralModulosProdutos from './estoqueGeralModulosProdutos/sagas';
import estoqueproduto from './estoqueproduto/sagas';
import fechamentolmc from './fechamentolmc/sagas';
import gerencias from './gerencias/sagas';
import hooks from './hooks/sagas';
import inversorFrequencia from './inversorFrequencia/sagas';
import justificativaAlteracaoEncerrante from './justificativaAlteracaoEncerrante/sagas';
import justificativaContingencia from './justificativaContingencia/sagas';
import justificativaTrocaModoOperacional from './justificativaTrocaModoOperacional/sagas';
import language from './language/sagas';
import localidade from './localidade/sagas';
import locomotiva from './locomotiva/sagas';
import motorista from './motorista/sagas';
import notification from './notification/sagas';
import operacao from './operacao/sagas';
import operacaoabastecimento from './operacaoabastecimento/sagas';
import operacaoabastecimentoexterno from './operacaoabastecimentoexterno/sagas';
import operacaoafericao from './operacaoafericao/sagas';
import operacaobatelada from './operacaobatelada/sagas';
import operacaodiagnostico from './operacaodiagnostico/sagas';
import operacaoBateriaDbic from './operacaoBateriaDbic/sagas';
import operacaoestoqueposto from './operacaoestoqueposto/sagas';
import operacaoestoquetanque from './operacaoestoquetanque/sagas';
import operacaoLimpezaDvec from './operacaoLimpezaDvec/sagas';
import operacaoLimpezaTag from './operacaoLimpezaTag/sagas';
import operacaoLubrificacao from './operacaoLubrificacao/sagas';
import operacaomedicaotemperatura from './operacaomedicaotemperatura/sagas';
import operacaodreno from './operacaodreno/sagas';
import operacaorecebimento from './operacaorecebimento/sagas';
import operacaoRecebimentoNf from './operacaoRecebimentoNf/sagas';
import operacaoTotalizadorVeiculo from './operacaoTotalizadorVeiculo/sagas';
import operacaotransferencia from './operacaotransferencia/sagas';
import operacaovazaonaoautorizada from './operacaovazaonaoautorizada/sagas';
import perfilFrentista from './perfilFrentista/sagas';
import perfis from './perfis/sagas';
import pitStopJustificativa from './pitStopJustificativa/sagas';
import pitStopRegra from './pitStopRegra/sagas';
import posto from './posto/sagas';
import precoproduto from './precoproduto/sagas';
import preset from './preset/sagas';
import produto from './produto/sagas';
import safras from './safras/sagas';
import tagcomrestricao from './tagcomrestricao/sagas';
import tanquefisico from './tanquefisico/sagas';
import tanquevirtual from './tanquevirtual/sagas';
import terminal from './terminal/sagas';
import tipoAreia from './tipoAreia/sagas';
import uploadplanilhacliente from './uploadplanilhacliente/sagas';
import user from './user/sagas';
import usuario from './usuario/sagas';
import usuariofrentista from './usuariofrentista/sagas';
import veiculo from './veiculo/sagas';
import logsDescarregamentos from './LogsDescarregamentos/sagas';
import logsDescarregamentosItem from './LogsDescarregamentosItem/sagas';
import locomotivaRegistration from './locomotivaRegistration/sagas';
import manutencaoDvec from './manutencaoDvec/sagas';
import marcasveiculo from './marcasveiculo/sagas';
import medidor from './medidor/sagas';
import mensagemSistemaEquipamento from './mensagemSistemaEquipamento/sagas';
import mensagemSistemaEquipamentoPosto from './mensagemSistemaEquipamentoPosto/sagas';
import mensagemSistemaFrentista from './mensagemSistemaFrentista/sagas';
import mensagemSistemaMotorista from './mensagemSistemaMotorista/sagas';
import mensagemSistemaoEquipamentoKm from './mensagemSistemaoEquipamentoKm/sagas';
import mensagemSistemaOperacaoAgricola from './mensagemSistemaOperacaoAgricola/sagas';
import mensagemsistemaposto from './mensagemsistemaposto/sagas';
import modeloveiculo from './modeloveiculo/sagas';
import modulosCliente from './modulosCliente/sagas';
import notafiscalrecebida from './notafiscalrecebida/sagas';
import raizenerrologintegracao from './raizenerrologintegracao/sagas';
import raizenerrologintegracaoentradacomboio from './raizenerrologintegracaoentradacomboio/sagas';
import raizenerrologintegracaomovimentacaocomboio from './raizenerrologintegracaomovimentacaocomboio/sagas';
import raizenerrologintegracaomovimentacaoposto from './raizenerrologintegracaomovimentacaoposto/sagas';
import raizenerrologintegracaotransferencia from './raizenerrologintegracaotransferencia/sagas';
import retransregisintegracao from './retransregisintegracao/sagas';
import transportadora from './transportadora/sagas';
import corredor from './corredor/sagas';
import estoqueAreia from './estoqueAreia/sagas';

export default function* rootSata() {
  return yield all([
    /** EXPORT SAGA */
    excecaoMeta,
    recalculaTurno,
    alteracaoCentroCusto,
    recebimentoAreiaNf,
    transferenciaAreiaSilo,
    afericaoAreiaSilo,
    tiposDeEquipamentosVeiculo,
    retransregisintegracao,
    raizenerrologintegracaoentradacomboio,
    raizenerrologintegracaomovimentacaocomboio,
    raizenerrologintegracaomovimentacaoposto,
    raizenerrologintegracaotransferencia,
    raizenerrologintegracao,
    checkxmlnfrecebimentonf,
    preset,
    checkliberadoparaintegracao,
    transportadora,
    distribuidora,
    fechamentolmc,
    notafiscalrecebida,
    linhaAbastecimento,
    inversorFrequencia,
    pitStopRegra,
    pitStopJustificativa,
    mensagemSistemaoEquipamentoKm,
    mensagemSistemaOperacaoAgricola,
    mensagemSistemaMotorista,
    mensagemSistemaFrentista,
    mensagemSistemaEquipamentoPosto,
    mensagemSistemaEquipamento,
    mensagemsistemaposto,
    perfilFrentista,
    uploadplanilhacliente,
    empresacliente,
    clienteConfig,
    modulosCliente,
    tagcomrestricao,
    afericaoDvec,
    manutencaoDvec,
    edicaoAlinhamentoTanque,
    edicaoTrocaTanque,
    recebimento,
    turno,
    justificativaContingencia,
    justificativaAlteracaoEncerrante,
    estoqueGeralModulosProdutos,
    operacaoBateriaDbic,
    auditoriaSistemas,
    justificativaTrocaModoOperacional,
    alarmeSistema,
    alarmesSistemas,
    operacaoLubrificacao,
    perfis,
    gerencias,
    causasManutencoes,
    safras,
    operacaoTotalizadorVeiculo,
    operacaoLimpezaDvec,
    operacaoLimpezaTag,
    operacaoRecebimentoNf,
    auth,
    bico,
    drawer,
    language,
    medidor,
    produto,
    precoproduto,
    posto,
    comboio,
    dialog,
    dialogForm,
    notification,
    terminal,
    estoqueAreia,
    tipoAreia,
    motorista,
    empresaveiculo,
    estoqueproduto,
    hooks,
    user,
    modeloveiculo,
    operacao,
    operacaoabastecimento,
    operacaoabastecimentoexterno,
    operacaoestoqueposto,
    operacaoestoquetanque,
    operacaorecebimento,
    operacaovazaonaoautorizada,
    operacaotransferencia,
    marcasveiculo,
    centrocusto,
    cercasvirtuais,
    contrato,
    usuario,
    veiculo,
    locomotiva,
    tanquevirtual,
    tanquefisico,
    arqueacao,
    configuracaoalarmetanque,
    consultaavancada,
    localidade,
    operacaoafericao,
    cadastrodvec,
    operacaobatelada,
    operacaodiagnostico,
    operacaomedicaotemperatura,
    operacaodreno,
    usuariofrentista,
    arqueacaoautomatica,
    logsDescarregamentos,
    logsDescarregamentosItem,
    locomotivaRegistration,
    corredor,
    conversorEntradaSaida,
  ]);
}
